/**
 * The dashboard card. Today's set (or the latest, if today's hasn't landed
 * yet), the coaching point, the streak, and the vote. Tap it to open the
 * X&O page with the sheet up. Renders nothing for a player development
 * coach who hasn't switched it on, and nothing while it's still deciding.
 */
import React from "react";
import { ChevronRight, Flame } from "lucide-react";
import { GOLD } from "../constants/theme";
import { useSotdFeed, useSotdVisibility, useStreak, kindWord, fmtSotdDate } from "./setOfDay";
import { VideoThumb } from "../components/VideoThumb";

const ff = "'DM Sans', sans-serif";

export function SetOfDayCard({ C, go, wrapClass = "" }) {
  const vis = useSotdVisibility();
  const { latest, loading } = useSotdFeed(vis.visible);
  const { streak, openedToday } = useStreak();
  if (!vis.visible || loading || !latest) return null;

  const open = () => {
    try { sessionStorage.setItem("bam_open_sotd", JSON.stringify({ id: latest.id })); } catch {}
    go("playbook");
  };
  // The same media row as the drill of the day beside it: frame, eyebrow,
  // title, one line. The coaching point and the vote are in the sheet this
  // opens; on the home page they made this card twice the height of its
  // neighbour.
  const kind = kindWord(latest, true);
  const date = fmtSotdDate(latest.sotdDate);
  return (
    <div className={`bam-sotd ${wrapClass}`.trim()} style={{ display: "flex", flex: 1, animationDelay: "0.5s" }}>
    <div onClick={open} role="button" tabIndex={0} onKeyDown={e => { if (e.key === "Enter") open(); }}
      className="btn bam-thumb-card"
      style={{ flex: 1, boxSizing: "border-box", position: "relative", overflow: "hidden", borderRadius: 14, background: C.cardGradient, border: `1px solid ${C.cardBorder}`,
        display: "flex", alignItems: "center", gap: 14, padding: 12, cursor: "pointer", fontFamily: ff }}>
      <div style={{ position: "relative", flexShrink: 0, width: 132, aspectRatio: "16/9", borderRadius: 10, overflow: "hidden", background: "#000" }}>
        <VideoThumb playbackId={latest.muxPlaybackId} width={480} height={270}/>
      </div>
      <div style={{ minWidth: 0, flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ fontSize: 10.5, fontWeight: 800, color: C.textMid, letterSpacing: 1.3, textTransform: "uppercase" }}>
          {kind} of the day{date ? ` · ${date}` : ""}
        </span>
        <div style={{ fontSize: 15, fontWeight: 800, color: C.text, lineHeight: 1.25, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{latest.title}</div>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, color: C.textMid }}>
          {streak > 0 && (
            <span title={openedToday ? "You've opened today's" : "Open today's to keep it going"}
              style={{ display: "inline-flex", alignItems: "center", gap: 3, fontWeight: 700, color: openedToday ? GOLD : C.textMid }}>
              <Flame size={11}/> Day {streak} ·
            </span>
          )}
          Open <ChevronRight size={13}/>
        </span>
      </div>
    </div>
    </div>
  );
}

export default SetOfDayCard;
